import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    no: "01",
    title: "Private Dining & Chef's Table",
    desc: "An intimate multi-course dinner staged in your own home or estate — Kasey cooks, plates and narrates each course tableside.",
    features: ["6–14 guests", "Tableside plating", "Sommelier on request"],
  },
  {
    no: "02",
    title: "Luxury Weddings & Estates",
    desc: "Full-service wedding gastronomy, from the champagne hour to the late-night course — choreographed with your planner to the minute.",
    features: ["Up to 250 guests", "Tasting for two included", "Full bar & service team"],
  },
  {
    no: "03",
    title: "Corporate Galas & Summits",
    desc: "Boardroom dinners, product launches and gala fundraisers executed with quiet precision and zero operational footprint.",
    features: ["Passed & seated formats", "Dietary matrix managed", "Venue coordination"],
  },
  {
    no: "04",
    title: "Bespoke Culinary Tastings",
    desc: "A working session at the tasting counter — compose your event menu course by course alongside the chef before you commit.",
    features: ["By appointment", "Seasonal menu draft", "Wine pairing flight"],
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-bone py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mute">
          What We Stage
        </p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-noir sm:text-4xl lg:text-5xl">
          Four rooms, one <span className="italic text-truffle">standard</span>
        </h2>
      </Reveal>

      <div>
        {SERVICES.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.08}>
            <a
              href={`mailto:kas@kaseybeaumont.com?subject=${encodeURIComponent(
                `Enquiry — ${s.title}`,
              )}`}
              data-testid={`service-row-${s.no}`}
              className="group grid gap-4 border-t border-noir/10 py-10 transition-colors duration-500 last:border-b hover:bg-linen/60 md:grid-cols-[80px_1fr_1.2fr_40px] md:items-center md:gap-8 md:px-4"
            >
              <span className="font-mono text-sm text-gold">{s.no}</span>
              <h3 className="font-serif text-2xl tracking-tight text-noir transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl">
                {s.title}
              </h3>
              <div>
                <p className="text-sm leading-relaxed text-ink-soft sm:text-base">{s.desc}</p>
                <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-1">
                  {s.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-mute"
                    >
                      <span className="h-1 w-1 rounded-full bg-gold" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
              <ArrowUpRight
                size={22}
                className="hidden text-noir/30 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-gold md:block"
              />
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
